import React from 'react';
import '../../assets/css/animation.css'

const SpeakerIcon = () => {
  return (
    <svg
        className="play-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 63 63"
    >
        <defs></defs>
        <g fill="none" fillRule="evenodd">
        <circle
            cx="31.3"
            cy="31.3"
            r="30.3"
            fill="currentColor"
            fillOpacity=".2"
            stroke="currentColor"
            strokeWidth="2"
        ></circle>
        <path
            fill="currentColor"
            d="M39.5 34.3l-11.3 7.5a2 2 0 01-3-1.6v-15a2 2 0 013-1.7L39.5 31a2 2 0 010 3.3z"
        ></path>
        </g>
    </svg>
  );
};

export default SpeakerIcon;